import React from 'react';
import { motion } from 'framer-motion';
import { LANDING } from '@/constants/testIds';
import { scrollToId } from '@/hooks/useLenis';

const items = [
    { n: '01', title: 'Estar presente', desc: 'Bloquea 30 min sin notificaciones. Esta sesión define si la misión es para ti.' },
    { n: '02', title: 'Estar dispuesto', desc: 'Mente abierta. Revisamos tus objetivos reales, no los ideales de brochure.' },
    { n: '03', title: 'Algo donde anotar', desc: 'Cuaderno o notas digitales. Sales con acciones concretas, no con inspiración vaga.' },
    { n: '04', title: 'Contexto de empresa', desc: 'Ten a mano tu propuesta de valor, mercados actuales y expectativas de escala.' },
];

const MentalPrep = () => (
    <section id="sesion-info" className="relative py-16 md:py-20 border-t border-white/10 bg-[color:var(--surface)]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
            <div className="grid grid-cols-12 gap-5 md:gap-8 mb-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="col-span-12 md:col-span-7"
                >
                    <div className="eyebrow-brand mb-6">La sesión de orientación</div>
                    <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                        No es una venta.<br />
                        <span className="italic-accent text-[color:var(--brand)] font-normal">Es una evaluación mutua.</span>
                    </h2>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                    className="col-span-12 md:col-span-5 md:pt-4"
                >
                    <p className="text-white/75 text-lg leading-relaxed">
                        30 minutos con nuestro equipo para definir si tu empresa tiene el perfil,
                        si estás preparado para ir y qué objetivos gana-gana vamos a fijar. Trae esto:
                    </p>
                </motion.div>
            </div>

            <ul data-testid={LANDING.mentalPrepList} className="grid grid-cols-1 md:grid-cols-4 gap-px bg-white/10 border border-white/10 mb-8">
                {items.map((it, i) => (
                    <motion.li
                        key={it.n}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.6, delay: i * 0.08 }}
                        className="relative bg-[color:var(--bg)] p-6 md:p-8 min-h-[220px] flex flex-col justify-between"
                    >
                        <div className="num-display text-[color:var(--brand)] text-4xl md:text-5xl">
                            {it.n}
                        </div>
                        <div>
                            <div className="font-display text-white text-xl md:text-2xl mb-2">{it.title}</div>
                            <p className="text-white/70 text-sm md:text-base leading-relaxed">{it.desc}</p>
                        </div>
                    </motion.li>
                ))}
            </ul>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border border-white/12 bg-[color:var(--surface)] p-8"
            >
                <div className="flex-1">
                    <div className="eyebrow-brand mb-2">Siguiente paso</div>
                    <div className="font-display text-white text-2xl md:text-3xl leading-tight">
                        Agenda tu sesión — sin costo, sin compromiso.
                    </div>
                </div>
                <button
                    onClick={() => scrollToId('sesion')}
                    className="btn-primary flex-shrink-0"
                >
                    Solicitar sesión
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </motion.div>
        </div>
    </section>
);

export default MentalPrep;
